itsoftApp.createModule("scrollActions", ["startLoad"], function () {
    const module = this;
    let registeredPlugin = false;
    let registeredScrollTriggerPlugin = false;
    // const getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;

    const libraries = {
        gsap: {
            name: "gsap",
            queue: [],
            started: false,
            loaded: false,
            scriptMore: "/assets/scripts/gsap/ScrollTrigger.min.js",
            script: "/assets/scripts/gsap/gsap.min.js"
        }
    };

    const initScrollActions = function (element, scrollTriggerFlag, cb) { 
        const initScrollExemplar = function () {
            if (!registeredPlugin) {
                registeredPlugin = true;

                if (!registeredScrollTriggerPlugin && scrollTriggerFlag) {
                    gsap.registerPlugin(ScrollTrigger); // eslint-disable-line
                }
            }

            if (cb && typeof cb === "function") {
                cb();
            } else {
                ScrollTrigger.clearScrollMemory(); // eslint-disable-line
                if (element.classList.contains("js-trigger-nav")) {
                    const extraMenu = element.querySelector(".js-extra-menu");

                    const setActive = function (link) {
                        const paddingLeft = getComputedStyle(extraMenu).paddingLeft || 0;
                        links.forEach(el => el.parentNode.classList.remove("js-active"));
                        link.parentNode.classList.add("js-active");
                        const scroll = link.parentNode.offsetLeft - parseInt(paddingLeft, 10);
                        menu.scrollLeft = scroll;
                    };

                    const menu = element.querySelector(".js-trigger-menu");
                    let links = gsap.utils.toArray(".js-trigger-nav-link"); // eslint-disable-line

                    links.forEach(a => {
                        let element = document.querySelector(a.getAttribute("href"));

                        ScrollTrigger.create({ // eslint-disable-line
                            trigger: element,
                            start: "top 25%",
                            end: "bottom 25%",
                            onToggle: self => self.isActive && setActive(a)
                        });
                    });
                }

                if (element.classList.contains("js-first-section")) {
                    let mm = gsap.matchMedia(); // eslint-disable-line
                    const firstBlock = element.querySelector(".js-first-block");
                    const firstBlockBgColor = firstBlock.getAttribute("data-bg-color") || "32, 22, 119";
                    const mainContent = element.querySelector(".js-main-content");
                    const slogan = element.querySelector(".js-slogan");
                    const solutionText = element.querySelector(".js-solution-text");
                    const iconFillElements = gsap.utils.toArray(".js-icon-fill"); // eslint-disable-line
                    const iconStrokeElements = gsap.utils.toArray(".js-icon-stroke"); // eslint-disable-line
                    let activeFlag = false;
                    // const transformValue = (slogan && slogan.getAttribute("data-transform")) || -42;

                    gsap.config({ // eslint-disable-line
                        nullTargetWarn: false
                    });

                    mainContent.classList.add("js-start");

                    mm.add("(min-width: 768px)", () => {
                        let tl = gsap.timeline({ // eslint-disable-line
                            scrollTrigger: {
                                trigger: element,
                                pin: true,
                                pinSpacing: "margin",
                                toggleActions: "play pause reverse pause",
                                start: element.hasAttribute("data-start") ? element.getAttribute("data-start") : "top-=76 top",
                                end: () => "+=" + element.clientHeight,
                                onUpdate: (self) => {
                                    if (self.progress >= 0.8 && !activeFlag) {
                                        activeFlag = true;
                                        firstBlock.classList.add("js-inactive");
                                        mainContent.classList.add("js-active");
                                    } else if (self.progress < 0.8 && activeFlag) {
                                        activeFlag = false;
                                        firstBlock.classList.remove("js-inactive");
                                        mainContent.classList.remove("js-active");
                                    }
                                },
                                invalidateOnRefresh: true,
                                scrub: true,
                            // markers: true
                            //   scrub: true,
                            }
                        });

                        tl.addLabel("start")
                        .set(firstBlock, {backgroundColor: "rgba(" + firstBlockBgColor + ", 1)"})
                        .set(slogan, {color: "white"})
                        .to(slogan, {y: 0, duration: 4}, "start")
                        .addLabel("afterStart")
                        .to(iconFillElements, {fill: "#101088", duration: 4}, "afterStart")
                        .to(iconStrokeElements, {stroke: "#101088", duration: 4}, "afterStart")
                        .fromTo(firstBlock, {backgroundColor: "rgba(" + firstBlockBgColor + ", 1)"}, {backgroundColor: "rgba(" + firstBlockBgColor + ", 0)", duration: 4}, "afterStart")
                        .fromTo(slogan, {opacity: 1, color: "white"}, {opacity: 0.2, color: "#101088", duration: 4}, "afterStart")
                        .fromTo(solutionText, {opacity: 1}, {opacity: 0, yPercent: 100, duration: 4}, "afterStart")
                        .addLabel("firstIteration")
                        .fromTo(mainContent, {opacity: 0}, {opacity: 1, duration: 4}, "firstIteration");
                    });
                }

                if (element.classList.contains("js-bg-anim")) {
                    const sliderTarget = element.querySelector(".js-trigger-slider");
                    const slidesNames = element.querySelector(".js-slides-names");
                    const slideNameEls = slidesNames.querySelectorAll(".js-slide-name");

                    sliderTarget.classList.add("js-visible");

                    let sliderSettingsKey = sliderTarget.getAttribute("data-slider-settings"); // получаем data-атрибут
                    const sliderSettingsObject = itsoftApp.modules.slidersSettings.getSettings(sliderSettingsKey); // получаем объект конфига

                    if (sliderTarget.classList.contains("js-slider")) {
                        if (sliderSettingsKey && sliderSettingsObject) {
                            new itsoftApp.modules.slidersLibrary.callback(sliderTarget, sliderSettingsObject);
                        } else {
                            new itsoftApp.modules.slidersLibrary.callback(sliderTarget);
                        }
                    }

                    const slideButtons = element.querySelectorAll(".js-slide-button");
                    const thumbsStroke = element.querySelectorAll(".js-thumb-stroke");

                    const defaultDuration = 6;
                    let activeIndex = 0;
                    let activeAnimation = null;
                    let activeCircle = thumbsStroke[0];

                    const stopCircle = function (anim) {
                        slideButtons[activeIndex].classList.remove("js-active");
                        slideNameEls[activeIndex].classList.remove("js-active");

                        if (!anim) {
                            activeAnimation && activeAnimation.kill();

                            if (activeAnimation) {
                                activeAnimation = null;

                                gsap.set(activeCircle, {strokeDasharray: thumbsStroke[0].getTotalLength()}); // eslint-disable-line
                                gsap.set(activeCircle, {strokeDashoffset: thumbsStroke[0].getTotalLength()}); // eslint-disable-line
                            }
                        } else {
                            anim.kill();
                        }
                    };

                    const startCircle = function (index) {
                        stopCircle();
                        activeIndex = index;
                        slideButtons[activeIndex].classList.add("js-active");
                        slideNameEls[activeIndex].classList.add("js-active");
                        Swiper.initedSliders["substances"].slideTo(index); // eslint-disable-line

                        activeCircle = thumbsStroke[index];

                        activeAnimation = gsap.to(activeCircle, { // eslint-disable-line
                            strokeDashoffset: 0,
                            duration: defaultDuration,
                            ease: "none",
                            // paused: true,
                            onComplete: function () {
                                if (index == thumbsStroke.length - 1) {
                                    Swiper.initedSliders["substances"].slideTo(0); // eslint-disable-line
                                } else {
                                    Swiper.initedSliders["substances"].slideTo(++index); // eslint-disable-line
                                }
                            },
                            clearProps: "all"
                        });
                    };

                    const initAutoSlider = function () {
                        Swiper.initedSliders["substances"].on("slideChange", function () { // eslint-disable-line
                            const swiper = this;
                            const currentActiveIndex = swiper.activeIndex;
                            startCircle(currentActiveIndex);
                        });

                        Array.prototype.forEach.call(slideButtons, function (item, index) {
                            gsap.set(thumbsStroke[index], {strokeDasharray: thumbsStroke[0].getTotalLength()}); // eslint-disable-line
                            gsap.set(thumbsStroke[index], {strokeDashoffset: thumbsStroke[0].getTotalLength()}); // eslint-disable-line

                            item.addEventListener("click", function (evt) {
                                evt.preventDefault();

                                Swiper.initedSliders["substances"].slideTo(index); // eslint-disable-line
                            });
                        });

                        startCircle(activeIndex);
                    };

                    itsoftApp.loadScript("/assets/scripts/lottie/lottie_light.min.js", () => {
                        const bgBlock = element.querySelector(".js-bg-block");
                        const pathName = bgBlock.getAttribute("data-lottie-bg");
                        
                        var LottieScrollTrigger = function (vars, settings) {
                            let playhead = {frame: 0};
                            let target = vars.target;
                            let st = {
                                trigger: target,
                                start: "center center"
                            };

                            if (pathName === "gel") {
                                settings.rendererSettings.preserveAspectRatio = "none";
                            }

                            let animation = lottie.loadAnimation(settings); // eslint-disable-line
            
                            for (let p in vars) {
                                st[p] = vars[p];
                            }
            
                            animation.addEventListener("DOMLoaded", function () {
                                gsap.to(playhead, { // eslint-disable-line
                                    frame: animation.totalFrames - 1,
                                    ease: "none",
                                    duration: "2",
                                    repeat: pathName === "neo" ? "-1" : false,
                                    onUpdate: () => animation.goToAndStop(playhead.frame, true),
                                    onComplete: function () {
                                        sliderTarget.classList.add("js-bg-complete");

                                        if (sliderTarget.classList.contains("js-slider")) {
                                            initAutoSlider();
                                        }
                                    },
                                    scrollTrigger: st
                                });

                                if (pathName === "neo") {
                                    setTimeout(function () {
                                        sliderTarget.classList.add("js-bg-complete");
                                        initAutoSlider();
                                    }, 1000);
                                }
            
                                ScrollTrigger.refresh(); // eslint-disable-line
                            });
                            return animation;
                        };

                        const bgPath = {
                            default: "/media/lottie/bg-default.json",
                            neo: "/media/lottie/bg-neo.json",
                            gel: "/media/lottie/bg-gel.json"
                        };

                        LottieScrollTrigger({
                            target: bgBlock,
                            path: bgPath[pathName],
                            speed: "+=10000"
                        }, {
                            rendererSettings: {
                                progressiveLoad: true
                            },
                            container: bgBlock, // the dom element that will contain the animation
                            renderer: "svg",
                            path: bgPath[bgBlock.getAttribute("data-lottie-bg")],
                            autoplay: pathName === "neo" ? true : false
                        });
                    });
                }
            }
        };

        new itsoftApp.modules.startLoad.callback(initScrollExemplar, libraries.gsap);
    };

    module.callback = initScrollActions;
});